import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import fileDownload from "js-file-download";
import { DateTime } from "luxon";
import { RequestType } from "pages/RequestIndex/RequestIndex";
import { Button } from "swing-components";

import { exportRequests, translate } from "~utils";

type ExportRequestsProps = {
  requestType: RequestType;
  onSuccess: () => void;
  onFailure: () => void;
};

const fileName = (requestType: RequestType) => {
  const since = DateTime.now().minus({ months: 12 }).toFormat("MM.dd.yyyy");
  const now = DateTime.now().toFormat("MM.dd.yyyy");
  const suffix = requestType === "past-requests" ? `${since}-${now}` : now;
  return `SwingSubsData-${suffix}.csv`;
};

export function ExportRequests(props: ExportRequestsProps) {
  const { requestType, onSuccess, onFailure } = props;
  const [isDisabled, setIsDisabled] = useState(false);

  const { mutate: invokeExportRequests } = useMutation({
    mutationFn: async () => {
      setIsDisabled(true);
      const fileBlob = await exportRequests(requestType);
      fileDownload(fileBlob, fileName(requestType));
    },
    onSuccess: () => {
      setIsDisabled(false);
      onSuccess();
    },
    onError: () => {
      setIsDisabled(false);
      onFailure();
    },
  });

  return (
    <Button
      aria-label={translate("EXPORT_REQUEST_LABEL")}
      status={isDisabled ? "disabled" : "enabled"}
      onClick={() => invokeExportRequests()}
      icon={{ name: "Download" }}
      type="tertiary"
    >
      {translate("EXPORT_REQUEST_LABEL")}
    </Button>
  );
}
